module.exports = __webpack_public_path__ + "media/images/top/user-dummy-223e9f6e5364064e26ef39458d2163b7.png";